export const SIGNUP_REQUESTING = "SIGNUP_REQUESTING";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SIGNUP_STATS_CHANGE = "SIGNUP_STATS_CHANGE";
export const SIGNUP_INPUT_CHANGE = "SIGNUP_INPUT_CHANGE";
export const SIGNUP_PROGRESS_CHANGE = "SIGNUP_PROGRESS_CHANGE";
export const SIGNUP_CHOICE_ADD = "SIGNUP_CHOICE_ADD";
export const SIGNUP_CHOICE_REMOVE = "SIGNUP_CHOICE_REMOVE";
export const SIGNUP_SUBMIT_REQUESTING = "SIGNUP_SUBMIT_REQUESTING";
export const SIGNUP_ONBOARDING_END_REQUESTING =
  "SIGNUP_ONBOARDING_END_REQUESTING";
export const SIGNUP_PROGRESS_CHANGE_RATIO = "SIGNUP_PROGRESS_CHANGE_RATIO";

export const SIGNUP_CLICK_TOPIC = "SIGNUP_CLICK_TOPIC";

export const GET_CLIENT_REQUESTING = "GET_CLIENT_REQUESTING";
export const GET_CLIENT_SUCCESS = "GET_CLIENT_SUCCESS";
export const GET_CLIENT_ERROR = "GET_CLIENT_ERROR";

export const CHECK_MAGIC_CODE_REQUESTING = "signup/CHECK_MAGIC_CODE_REQUESTING";
export const CHECK_MAGIC_CODE_SUCCESS = "signup/CHECK_MAGIC_CODE_SUCCESS";
export const CHECK_MAGIC_CODE_ERROR = "signup/CHECK_MAGIC_CODE_ERROR";

export const SIGNUP_SURVEY_SET_STATS = "signup/SIGNUP_SURVEY_SET_STATS";
